import React, { Suspense, lazy } from 'react';
import "./Activities.css";
import { getStoredData } from "../../json/fetchData.js";

// Lazy load the components
const AllIntroTemplate = lazy(() => import("../../components/AllIntroTemplate/AllIntroTemplate.js"));
const ActivitiesCard = lazy(() => import('../../components/ActivitiesCard/ActivitiesCard.js'));
const ContentModel = lazy(() => import("../../components/ContentModel/ContentModel.js"));

const Activities = () => {
  const totalData = getStoredData();
  const data = totalData ? totalData["28"] : {};

  return (
    <div>
      <Suspense fallback={<div>Loading intro...</div>}>
        <AllIntroTemplate image={data.Image} title={data.Title} page={totalData ? totalData["0"] : {}}/>
      </Suspense>

      <Suspense fallback={<div>Loading activities...</div>}>
        <ActivitiesCard/>
      </Suspense>

      <Suspense fallback={<div>Loading content...</div>}>
        <ContentModel data={totalData ? totalData["28"] : {}}/>
      </Suspense>
    </div>
  )
}

export default Activities;
